import {
  ScheduleProps,
  translatedScheduleProps,
  translatedWorkingPeriodProps,
  WorkingPeriodProps,
} from 'modules/companies/types';
import weekDaySelect from 'modules/notifications/util/week-day-select';
import useEditWorkingPeriod from 'modules/products/hooks/use-edit-working-period';
import {useLocation, useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateWorkingPeriod: React.FC = () => {
  const {id} = useParams();
  const {state: workingPeriod} = useLocation();
  const {getSelect, getSwitch, getDynamicSection} =
    useFormInputs<WorkingPeriodProps>();
  const {getTimePicker} = useFormInputs<ScheduleProps>();

  return (
    <Creation
      defaultValues={{active: true, ...(workingPeriod ?? {})}}
      translationKey={translatedWorkingPeriodProps}
      onSubmit={() => useEditWorkingPeriod(id!)}
      inputs={[
        getSelect({name: 'day', data: weekDaySelect}),
        getSwitch({name: 'active'}),
        getDynamicSection({
          name: 'schedules',
          inputs: [
            getTimePicker({name: 'start'}),
            getTimePicker({name: 'end'}),
          ],
          translationKey: translatedScheduleProps,
        }),
      ]}
      border
    />
  );
};

export default CreateWorkingPeriod;
